// Item types are stored inconsistently ('RAW_MATERIAL' vs 'Raw Material') — normalize for the badge
const ITEM_TYPE_BADGES: Record<string, { label: string; cls: string; icon: string }> = {
  RAW_MATERIAL: { label: 'Raw Material', cls: 'bg-sky-50 text-sky-700 border-sky-200', icon: 'ri-stack-line' },
  SEMI_FINISHED: { label: 'Semi-Finished', cls: 'bg-violet-50 text-violet-700 border-violet-200', icon: 'ri-settings-4-line' },
  FINISHED_GOOD: { label: 'Finished Good', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200', icon: 'ri-checkbox-circle-line' },
  PACKAGING: { label: 'Packaging', cls: 'bg-amber-50 text-amber-700 border-amber-200', icon: 'ri-gift-2-line' },
  CONSUMABLE: { label: 'Consumable', cls: 'bg-orange-50 text-orange-700 border-orange-200', icon: 'ri-drop-line' },
  SERVICE: { label: 'Service', cls: 'bg-slate-100 text-slate-600 border-slate-200', icon: 'ri-customer-service-2-line' },
};

export default function ItemTypeBadge({ type }: { type?: string | null }) {
  if (!type) return null;
  const key = String(type).trim().toUpperCase().replace(/[\s-]+/g, '_');
  const badge = ITEM_TYPE_BADGES[key] || {
    label: String(type).replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase()),
    cls: 'bg-slate-100 text-slate-600 border-slate-200',
    icon: 'ri-price-tag-3-line',
  };
  return (
    <span className={`inline-flex items-center gap-1 px-1.5 py-px rounded-md text-[10px] font-semibold border whitespace-nowrap ${badge.cls}`}>
      <i className={`${badge.icon} text-[10px]`} />
      {badge.label}
    </span>
  );
}
